import Vue from 'vue';

interface ILayoutElements {
    state: ILayoutElementsState;
    resetState: () => void;
    getPageHeader: () => HTMLElement;
    getPageFooter: () => HTMLElement;
    getFlyout: () => HTMLElement;
}

interface ILayoutElementsState {
    pageHeader?: HTMLElement;
    pageFooter?: HTMLElement;
    flyout?: HTMLElement;
}

const defaultState: ILayoutElementsState = {
    pageHeader: null,
    pageFooter: null,
    flyout: null
}

const state: ILayoutElementsState = Vue.observable({
    ...defaultState
});

// mutations
const resetState = () => {
    state.pageHeader = null
    state.pageFooter = null
    state.flyout = null
}

const getPageHeader = (): HTMLElement => {
    if (!state.pageHeader) {
        state.pageHeader = document.querySelector('.js-head');
    }
    return state.pageHeader;
};
const getPageFooter = (): HTMLElement => {
    if (!state.pageFooter) {
        state.pageFooter = document.querySelector('.footer');
    }
    return state.pageFooter;
}

const getFlyout = (): HTMLElement => {
    if (!state.flyout) {
        state.flyout = document.querySelector('.flyout');
    }
    return state.flyout;
}

// actions
const useLayoutElements = (): ILayoutElements => {
    return {
        state,
        resetState,
        getPageHeader,
        getPageFooter,
        getFlyout
    };
};

export {useLayoutElements};
